import React, { useState, useEffect } from 'react';
import API from '../../../Services/BaseService';
import { useHistory, useLocation, useParams } from "react-router-dom";
import CommonPopup from '../../../Component/CommonPopup/CommonPopup';
import "../../../Component/CommonPopup/commonPopup.css"
import { useDispatch, useSelector } from 'react-redux';
import ls from 'local-storage';
/* import { Button } from "antd"; */
import ErrorPopup from '../../FallBackUI/ErrorPopup';
import Loading from "../../../Component/Loading/Loading";
import { Modal, Button } from 'react-bootstrap';

const ViewTitlePopup = (props) => {

  const history = useHistory();

  const [isCommonPopupOpen, setIsCommonPopupOpen] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMsg, setPopupMsg] = useState("");
  const [popupType, setPopupType] = useState("");
  const [popupActionType, setPopupActionType] = useState("");
  const [popupActionValue, setPopupActionValue] = useState("");
  const [popupActionPath, setPopupActionPath] = useState("");
  const [alertmessage, setAlertMessage] = useState("");
  const [alerttitle, setAlertTitle] = useState("");
  const [alertimg, setAlertImg] = useState("");
  const [comments, setComments] = useState();
  const [commentsError, setCommentsError] = useState("");
  const adminData = useSelector(state => state.LoginReducer.payload);
  const [togglePopupOpen, setTogglePopupOpen] = useState(true);
  const [notesList, setNotesList] = useState("");
  const [manageState, setManageState] = useState("");
  const [selectedManageState, setSelectedManageState] = useState("");
  const [stateId, setStateId] = useState("");
  const [lights, setLights] = useState("");
  const [car, setCar] = useState(props.car);
  const [sellerID, setSellerID] = useState("");
  const [titleComments, setTitleComments] = useState();
  const [stateNameList, setStateNameList] = useState([]);
  const [title, setTitle] = useState("");
  // console.log("setloading",loading);
  const successData = useSelector(state => state.LoginReducer.payload);

  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);

  const toggleCommonPopup = () => {
    setIsCommonPopupOpen(!isCommonPopupOpen);
  }


  const valueComments = ls.get('comments');


  const saveAdd = () => {

    ls.set('comments', comments);


    setCommentsError("")

    if (!comments) {
      setCommentsError("Notes is required")
      return;
    }
    else if (comments.length > 500) {
      setCommentsError("Notes must not exceed 500 characters")
      return;
    }

    const recentlyAddednewvalue = [...notesList, comments]
    setNotesList([...notesList, comments])
    // props.addIF(recentlyAddednewvalue)

    // setComments(" ")
    // setTogglePopupOpen(false)
    console.log("notesList======", notesList)
    console.log("comments======", comments)
    console.log("recentlyAddednewvalue item======", recentlyAddednewvalue)

  }

  const titleView = () => {

    let request = {
      car_id: props.car,
      bill_of_sale_id:props.BosId,
      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
    }
    API.post("entertitle_view/condition", request).then((response) => {
      console.log("mailBankAccount", response.data.data);
      if (response.data.success === true) {
        setTitle(response.data?.data[0]);
        setTitleComments(response.data.data[0]?.title)
        // setBillofSale(response.data.data[0]?.bill_of_sale_id)
        setCar(response.data.data[0]?.car_id)
        setSellerID(response.data.data[0]?.seller_dealer_id)
        setStateId(response.data.data[0]?.title_state_id);
        setManageState(response.data.data[0]?.state_name);
        setLights(response.data.data[0]?.payment_status);
      }
      else {
        setErrors(response.data.error.name)
        setErrorFlag(true)
      }

    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)

      }
    });
  };

  useEffect(() => {
    titleView();
  }, []);

  const handleClose = () => {
    props.reCallFunction()
    props.toggle()
  }

  return (
    <>
      {errorFlag === true ? (
        <ErrorPopup error={errors} />
      ) : (
        <>
          <Modal show={props.toggle} onHide={handleClose}>
            <Modal.Header className="Terms-login">
              <Modal.Title>Edit Title</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div class="col-lg-12 col-md-6 mb-4">
                <label for="internal" class="form-label required">
                  Title #
                </label>
                <textarea class="form-control" id="internal" rows="2" defaultValue={title?.title} disabled></textarea>
              </div>

              <div class="col-lg-12 col-md-6 mb-4">
                <label for="state3" class={"form-label required"}>
                  State
                </label>
                <input type="text" class="form-control" id="Account" defaultValue={title?.state_name} disabled />
              </div>
              <h6 class="text-start mb-4 mt-4">Payment Mode</h6>
              <div class="form-check mb-3">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexLightsRadioDefault"
                  value="Ach"
                  id="vaacefhrlights"
                  checked={lights === "Ach"}
                  disabled
                />
                <label class="form-check-label ms-2 text-color1" for="vaacefhr">
                  ACH
                </label>
              </div>
              <div class="form-check mb-3">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefaultLights"
                  id="vaacefhrlights"
                  checked={lights === "check"}
                  value="check"
                  disabled
                />
                <label class="form-check-label ms-2 text-color1" for="vaacefhr">
                  Check
                </label>
              </div>
              <div className="Sellernotes">
                            <Button className="cta-btn" onClick={handleClose}>Close</Button>
                        </div>
            </Modal.Body>
          
          </Modal>
        </>
      )}
      {isCommonPopupOpen && (
        <CommonPopup
          handleClose={isCommonPopupOpen}
          popupTitle={popupTitle}
          popupMsg={popupMsg}
          popupType={popupType}
          popupActionType={popupActionType}
          popupActionValue={popupActionValue}
          popupActionPath={popupActionPath}
        />
      )}
    </>
  )
}

export default ViewTitlePopup